export default __webpack_public_path__ + "ced47807483fc56bcecd9a049e1a1f46.png";